"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
exports.__esModule = true;
exports.PropertyRatePlanCreateDto = void 0;
var class_validator_1 = require("class-validator");
var property_rate_plan_pricing_standalone_dto_1 = require("./property-rate-plan-pricing-standalone.dto");
var property_rate_plan_pricing_linked_dto_1 = require("./property-rate-plan-pricing-linked.dto");
var class_transformer_1 = require("class-transformer");
var rate_plan_event_dto_1 = require("./rate-plan-event.dto");
var PropertyRatePlanPricing = (function () {
    function PropertyRatePlanPricing() {
    }
    return PropertyRatePlanPricing;
}());
var PropertyRatePlanConditions = (function () {
    function PropertyRatePlanConditions() {
    }
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsDate(),
        class_transformer_1.Type(function () { return Date; }),
        __metadata("design:type", Date)
    ], PropertyRatePlanConditions.prototype, "startDate");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsDate(),
        class_transformer_1.Type(function () { return Date; }),
        __metadata("design:type", Date)
    ], PropertyRatePlanConditions.prototype, "endDate");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsNumber(),
        __metadata("design:type", Number)
    ], PropertyRatePlanConditions.prototype, "minStay");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsNumber(),
        __metadata("design:type", Number)
    ], PropertyRatePlanConditions.prototype, "maxStay");
    return PropertyRatePlanConditions;
}());
var PropertyRatePlanCreateDto = (function () {
    function PropertyRatePlanCreateDto() {
    }
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsBoolean(),
        __metadata("design:type", Boolean)
    ], PropertyRatePlanCreateDto.prototype, "isActive");
    __decorate([
        class_validator_1.IsNotEmpty(),
        class_validator_1.IsString(),
        __metadata("design:type", String)
    ], PropertyRatePlanCreateDto.prototype, "name");
    __decorate([
        class_validator_1.IsNotEmpty(),
        class_validator_1.IsString(),
        __metadata("design:type", String)
    ], PropertyRatePlanCreateDto.prototype, "cancellationPolicy");
    __decorate([
        class_validator_1.IsNotEmpty(),
        class_validator_1.IsString(),
        __metadata("design:type", String)
    ], PropertyRatePlanCreateDto.prototype, "type");
    __decorate([
        class_validator_1.IsNotEmpty(),
        class_validator_1.IsString(),
        __metadata("design:type", String)
    ], PropertyRatePlanCreateDto.prototype, "concept");
    __decorate([
        class_validator_1.IsArray(),
        class_validator_1.IsString({ each: true }),
        __metadata("design:type", Array)
    ], PropertyRatePlanCreateDto.prototype, "included");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.ValidateNested(),
        class_transformer_1.Type(function () { return PropertyRatePlanConditions; }),
        __metadata("design:type", PropertyRatePlanConditions)
    ], PropertyRatePlanCreateDto.prototype, "conditions");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsObject(),
        __metadata("design:type", Object)
    ], PropertyRatePlanCreateDto.prototype, "description");
    __decorate([
        class_validator_1.ValidateNested(),
        class_transformer_1.Type(function () { return PropertyRatePlanPricing; }, {
            discriminator: {
                property: 'type',
                subTypes: [
                    { value: property_rate_plan_pricing_standalone_dto_1.PropertyRatePlanPricingStandaloneDto, name: 'STANDALONE' },
                    { value: property_rate_plan_pricing_linked_dto_1.PropertyRatePlanPricingLinkedDto, name: 'LINKED' },
                ]
            },
            keepDiscriminatorProperty: true
        }),
        __metadata("design:type", Object)
    ], PropertyRatePlanCreateDto.prototype, "pricing");
    __decorate([
        class_validator_1.ValidateNested(),
        class_validator_1.IsOptional(),
        class_transformer_1.Type(function () { return rate_plan_event_dto_1.RatePlanEvent; }),
        __metadata("design:type", Array)
    ], PropertyRatePlanCreateDto.prototype, "events");
    return PropertyRatePlanCreateDto;
}());
exports.PropertyRatePlanCreateDto = PropertyRatePlanCreateDto;
//# sourceMappingURL=property-rate-plan-create.dto.js.map